
import { mapActions } from 'vuex'

export const split = {
	data () {
		return {
			isCreatingSplit : false,
		}
	},
	computed : {
		canMobile () {
			return [ 'floating', 'popup' ].includes(this.type)
		},
	},
	methods : {
		...mapActions('campaigns', [ 'splitCampaign' ]),
		splitting (status) {
			this.isCreatingSplit = status
		},
		split () {
			if (!this.isValid()) {
				return
			}

			this.splitting(true)

			this.splitCampaign({
				campaignId : this.campaign.id,
				params     : {
					name   : this.name,
					notes  : this.notes,
					mobile : this.canMobile && this.mobile,
					type   : this.type,
				},
			})
				.then(({ id }) => {
					const returnUrl = window.location.href
					window.location.href = this.$urls.campaign(id, 'edit/?isNew=true', returnUrl)
				})
				.finally(() => {
					this.splitting(false)
					this.$modal.hide(this.campaign.id + '-split-modal')
				})
		},
		isValid () {
			if (!this.name) {
				this.error = 'A name is required for the split test.'
				return false
			}

			return true
		},
	},
}
